// src/api/axiosConfig.ts
import axios from 'axios';

// Send cookies (httponly JWT) on every cross-site call
axios.defaults.withCredentials = true;

export default axios;
